import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class TktAvailabilityOptionsB2BPlugin implements Plugin {
  private buttons: NodeListOf<HTMLButtonElement>;
  private isMultiple: boolean;
  private options: any[];

  constructor(private readonly element: HTMLElement) {
    this.buttons = element.querySelectorAll(
      ".tkt-availability-options-b2b__tab",
    );
    this.isMultiple = element.dataset.multiple === "true";
    try {
      this.options = JSON.parse(element.dataset.options || "[]");
    } catch (e) {
      this.options = [];
      console.error("Failed to parse options for TktAvailabilityOptionsB2B", e);
    }
  }

  init(): void {
    this.buttons.forEach((button, index) => {
      if (index < this.options.length) {
        button.addEventListener("click", () =>
          this.handleSelection(button, this.options[index]),
        );
      } else if (
        button.classList.contains("tkt-availability-options-b2b__tab--more")
      ) {
        button.addEventListener("click", () =>
          this.handleMoreSelection(button),
        );
      }
    });
  }

  private handleMoreSelection(button: HTMLButtonElement): void {
    this.toggleSelectionState(button);

    this.element.dispatchEvent(
      new CustomEvent("tkt-availability-options-b2b:more-selected", {
        detail: {
          selected: button.classList.contains(
            "tkt-availability-options-b2b__tab--selected",
          ),
        },
        bubbles: true,
      }),
    );
  }

  private handleSelection(
    selectedButton: HTMLButtonElement,
    optionData: any,
  ): void {
    this.toggleSelectionState(selectedButton, true);

    // Use data from the option object
    const value = optionData.value;
    const label = optionData.label;

    const selectedValues: string[] = [];
    if (this.isMultiple) {
      this.buttons.forEach((btn, idx) => {
        if (
          btn.classList.contains(
            "tkt-availability-options-b2b__tab--selected",
          ) &&
          idx < this.options.length
        ) {
          selectedValues.push(this.options[idx].value);
        }
      });
    }

    this.element.dispatchEvent(
      new CustomEvent("tkt-availability-options-b2b:change", {
        detail: {
          value,
          label,
          selected: selectedButton.classList.contains(
            "tkt-availability-options-b2b__tab--selected",
          ),
          allSelected: this.isMultiple ? selectedValues : [value],
        },
        bubbles: true,
      }),
    );
  }

  private toggleSelectionState(
    button: HTMLButtonElement,
    excludeMoreButtonFromDeselection: boolean = false,
  ): void {
    if (!this.isMultiple) {
      this.buttons.forEach((btn) => {
        if (btn !== button) {
          btn.classList.remove("tkt-availability-options-b2b__tab--selected");
          btn.setAttribute("aria-pressed", "false");
        }
      });

      button.classList.add("tkt-availability-options-b2b__tab--selected");
      button.setAttribute("aria-pressed", "true");
    } else {
      const isSelected = button.classList.contains(
        "tkt-availability-options-b2b__tab--selected",
      );
      if (isSelected) {
        button.classList.remove("tkt-availability-options-b2b__tab--selected");
        button.setAttribute("aria-pressed", "false");
      } else {
        button.classList.add("tkt-availability-options-b2b__tab--selected");
        button.setAttribute("aria-pressed", "true");
      }
    }
  }
}

PluginRegistry.register(
  "tkt-availability-options-b2b",
  TktAvailabilityOptionsB2BPlugin,
);
